export const RIDER_LEVEL_OPTIONS = [
  { value: "BEGINNER", label: "Beginner" },
  { value: "INTERMEDIATE", label: "Intermediate" },
  { value: "ADVANCED", label: "Advanced" },
  { value: "EXPERT", label: "Expert" },
];

export const RIDING_STYLE_OPTIONS = ["Flow", "Enduro", "Downhill", "Jump Lines", "Technical", "XC-Trail"];
export const RIDING_CONTEXT_OPTIONS = ["Solo", "Friends", "Family-Kids"];
export const DESTINATION_PREFERENCE_OPTIONS = ["Lift", "Shuttle", "Pedal access", "Rental", "School", "Food"];

export const emptyRiderProfileForm = () => ({
  level: "",
  riding_styles: [],
  riding_contexts: [],
  destination_preferences: [],
});

export const profileToForm = (profile) => ({
  level: profile?.level ?? "",
  riding_styles: profile?.riding_styles ?? [],
  riding_contexts: profile?.riding_contexts ?? [],
  destination_preferences: profile?.destination_preferences ?? [],
});

export const formToRiderProfileInput = (form) => ({
  level: form.level || null,
  riding_styles: form.riding_styles.length ? form.riding_styles : null,
  riding_contexts: form.riding_contexts.length ? form.riding_contexts : null,
  destination_preferences: form.destination_preferences.length ? form.destination_preferences : null,
});

export const toggleProfileValue = (values, value) => (
  values.includes(value) ? values.filter((item) => item !== value) : [...values, value]
);

export const hasRiderProfilePreferences = (form) => Boolean(
  form.level
  || form.riding_styles.length
  || form.riding_contexts.length
  || form.destination_preferences.length
);
